const getTitle = (title, validations) => {
  let newTitle = title;
  if (validations && validations.indexOf('required') !== -1) {
    if (title.indexOf('*') === -1) {
      newTitle = `${title} *`;
    }
  }
  return newTitle;
};

/**
 * Funzione per generare guid random (necessaria per creare nomi univoci per gli input per fermare
 * l'autocomplete di chrome (https://gist.github.com/jed/982883)
 * @param {f} a
 */
function b(
  a, // placeholder
) {
  /* eslint-disable no-bitwise */
  return a // if the placeholder was passed, return
    ? ( // a random number from 0 to 15
      a // unless b is 8,
      ^ Math.random() // in which case
      * 16 // a random number from
      >> a / 4 // 8 to 11
    ).toString(16) // in hexadecimal
    : ( // or otherwise a concatenated string:
      [1e7] // 10000000 +
      + -1e3 // -1000 +
      + -4e3 // -4000 +
      + -8e3 // -80000000 +
      + -1e11 // -100000000000,
    ).replace( // replacing
      /[018]/g, // zeroes, ones, and eights with
      b, // random hex digits
    );
  /* eslint-enable */
}

const getRandomId = () => b();

/**
 * Calcola il valore di presentazione.
 */
class Presentation {
  constructor({ readOnly }) {
    this.readOnly = readOnly;
  }

  format(value) {
    if ((!value || value.length === 0) && this.readOnly) return '-';
    return value;
  }

  parse(text) {
    if (text === '-' && this.readOnly) return '';
    return text;
  }
}

export {
  getTitle,
  getRandomId,
  Presentation,
};
